export default {
  inserted: (el, binding) => {
    const loadImage = () => {
      el.onload = () => el.classList.add('loaded');
      el.src = binding.value;
    };

    const handleIntersect = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadImage();
          observer.unobserve(el);
        }
      });
    };

    const createObserver = () => {
      const options = { root: null, threshold: '0' };
      const observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(el);
    };

    if (window.IntersectionObserver) {
      createObserver();
      return;
    }
    loadImage();
  },
};
